var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GoBackView'),_c('MineHeaderView',{on:{"click-icon":_vm.openMenu}}),_c('MineMenuView',{ref:"mmv"}),_c('WallerStatistics',{attrs:{"usr":_vm.usrData},on:{"reset-record":_vm.resetRecord}}),_c('WallerRecordView',{ref:"record"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }